new Splide('.offers_slider', {
  type: 'loop',
  arrows: false,
  pagination: true,
  gap: '16px',
  perPage: 1.5,
  perMove: 1,
  breakpoints: {
    749: {
      perPage: 1.5,
      gap: '12px'
    },
    990: {
      perPage: 1.5
    }
  }
}).mount();